import { useState, useEffect } from 'react'
import { useAppSelector, useUserResources } from '@/utils/hooks'
import { validateModuleResource } from '@/utils/util'

const NotFound: React.FC = () => {
  const [loading] = useAppSelector(state => [state.loading])
  const [dataCenterRs, manageCenterRs] = useUserResources(rs => [rs.dataCenter, rs.manageCenter])

  const [tip, setTip] = useState('')

  useEffect(() => {
    if (loading.resource) {
      return setTip('资源加载中...')
    } else if (manageCenterRs.index && !loading.resource) {
      // 资源加载完成，访问的路径不正确
      return setTip('当前访问的页面不存在')
    } else if (validateModuleResource(dataCenterRs) && !validateModuleResource(manageCenterRs)) {
      // 资源加载完成，管理模块无此资源点
      return setTip('当前访问的页面不存在')
    }
    // 初始条件下，及兜底情况
    const timer = setTimeout(() => {
      setTip('当前访问的页面不存在')
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [loading])

  return <div className="centerCenter mt20">{tip}</div>
}

export default NotFound
